import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ProductGridSkeleton } from "./skeleton";
interface LoadingStateProps {
  type: "products";
  count?: number;
}
const LoadingState: React.FC<LoadingStateProps> = t0 => {
  const $ = _c(2);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 6 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = <ProductGridSkeleton count={count} />;
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};

// Empty state component
export const EmptyState: React.FC<{
  title?: string;
  message?: string;
  actionText?: string;
  onAction?: () => void;
}> = t0 => {
  const $ = _c(12);
  const {
    title: t1,
    message: t2,
    actionText: t3,
    onAction
  } = t0;
  const title = t1 === undefined ? "No products found" : t1;
  const message = t2 === undefined ? "We couldn't find any products matching your criteria. Try adjusting your filters." : t2;
  const actionText = t3 === undefined ? "Clear Filters" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="w-16 h-16 mb-4 rounded-full bg-gray-100 flex items-center justify-center"><svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" /></svg></div>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== title) {
    t5 = <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>;
    $[1] = title;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== message) {
    t6 = <p className="text-gray-600 mb-4 max-w-md">{message}</p>;
    $[3] = message;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== actionText || $[6] !== onAction) {
    t7 = onAction && <button onClick={onAction} className="px-4 py-2 bg-[#037a6a] text-white rounded-lg hover:bg-[#025e53] transition-colors">{actionText}</button>;
    $[5] = actionText;
    $[6] = onAction;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <div className="flex flex-col items-center justify-center py-12 text-center">{t4}{t5}{t6}{t7}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default LoadingState;

// Full-page spinner for route loading.tsx boundaries
interface PageSpinnerProps {
  text?: string;
}
export const PageSpinner = t0 => {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#037A6A] mb-4" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = text && <p className="text-[#444444] font-bold text-lg">{text}</p>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="min-h-screen bg-[#fcfcfc] flex flex-col items-center justify-center w-full"><div className="flex flex-col items-center">{t1}{t2}</div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};